"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheStore = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/CacheStore"));

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Handles changes done to the body elements.
 */
var ComponentBody = /*#__PURE__*/function (_EventHandler) {
  _inherits(ComponentBody, _EventHandler);

  var _super = _createSuper(ComponentBody);

  /**
   * Class constructor.
   *
   * @param {string} componentName Component name.
   * @param {Element[]} [children] Array of elements.
   */
  function ComponentBody(componentName) {
    var _this;

    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, ComponentBody);

    _this = _super.call(this, {
      supportedEvents: ['change'],
      componentName: componentName
    });

    var bodyElement = _this._getBodyElement(children);

    var bodyId = (_this.constructor.cacheStore.get('id') || 0) + 1;

    _this.constructor.cacheStore.set('id', bodyId);

    _this.id = bodyId;
    _this.element = bodyElement ? bodyElement : document.createElement('ikea-component-body');

    _this.element.setAttribute('data-body-id', _this.id);

    _this.useObserver = false;
    _this.observerOptions = {
      attributes: true,
      subtree: true,
      characterData: true,
      childList: true
    };

    if (_this.element.parentNode) {
      _this.element.parentNode.removeChild(_this.element);
    }

    _this._observer = null;
    _this._events = {
      change: []
    };
    _this._observerTimeout = null;

    if (children !== null && !bodyElement) {
      _this.setChildren(children);
    }

    return _this;
  }
  /**
   * Sets the body html.
   *
   * @param {string} html Body html to set.
   */


  _createClass(ComponentBody, [{
    key: "setHtml",
    value: function setHtml(html) {
      var body = document.createElement('div');
      body.innerHTML = html;
      this.setChildren(Array.from(body.childNodes));
    }
    /**
     * Sets child elements.
     *
     * @param {Element[]} children Array of elements.
     */

  }, {
    key: "setChildren",
    value: function setChildren(children) {
      for (var _i = 0, _Array$from = Array.from(this.element.childNodes); _i < _Array$from.length; _i++) {
        var child = _Array$from[_i];
        this.element.removeChild(child);
      }

      var _iterator = _createForOfIteratorHelper(children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _child = _step.value;
          var isWhiteSpace = _child.nodeType === Node.TEXT_NODE && _child.nodeValue.replace(/\s+/gm, '') === '';

          if (!isWhiteSpace) {
            if (_child.parentNode) {
              _child.parentNode.removeChild(_child);
            }

            this.element.appendChild(_child);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Adds an event listener.
     *
     * @param {string} name Event name.
     * @param {Function} listener The listener.
     */

  }, {
    key: "on",
    value: function on(name, listener) {
      _get(_getPrototypeOf(ComponentBody.prototype), "on", this).call(this, name, listener);

      if (name === 'change') {
        this._connectObserver();
      }
    }
    /**
     * Destroys the body. Disconnects the observer.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.element.removeAttribute('data-body-id');

      this._disconnectObserver();
    }
    /**
     * Returns the body element of a list of nodes.
     *
     * @param {Node[]} nodes Nodes.
     * @returns {Element|null} Body element.
     */

  }, {
    key: "_getBodyElement",
    value: function _getBodyElement(nodes) {
      var _iterator2 = _createForOfIteratorHelper(nodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;

          if (node.tagName === 'IKEA-COMPONENT-BODY' && !node.getAttribute('data-body-id')) {
            return node;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
    /**
     * Connects an observer on the elements.
     */

  }, {
    key: "_connectObserver",
    value: function _connectObserver() {
      var _this2 = this;

      if (this._observer === null && this.useObserver) {
        var allMutations = [];
        this._observer = new MutationObserver(function (mutations) {
          allMutations = allMutations.concat(mutations);
          clearTimeout(_this2._observerTimeout);
          _this2._observerTimeout = setTimeout(function () {
            _this2.trigger('change', allMutations);

            allMutations = [];
          });
        });

        this._observer.observe(this.element, this.observerOptions);
      }
    }
    /**
     * Disconnects observer on the elements.
     */

  }, {
    key: "_disconnectObserver",
    value: function _disconnectObserver() {
      clearTimeout(this._observerTimeout);

      if (this._observer !== null) {
        this._observer.disconnect();

        this._observer = null;
      }
    }
    /**
     * Converts the component body to an HTML string.
     *
     * @returns {string} HTML string.
     */

  }, {
    key: "toString",
    value: function toString() {
      return '<ikea-component-body data-body-id="' + this.id + '"></ikea-component-body>';
    }
    /**
     * Returns the cache store.
     *
     * @returns {CacheStore} Cache store.
     */

  }], [{
    key: "cacheStore",
    get: function get() {
      if (!this._cacheStore) {
        this._cacheStore = new _CacheStore.default('componentBody');
      }

      return this._cacheStore;
    }
  }]);

  return ComponentBody;
}(_EventHandler2.default);

exports.default = ComponentBody;